"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M8.5 8a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM13.75 8h2.5l-6 8h-2.5l6-8zM14 14.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z\" fill=\"#000\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 1l2.89 2.108 3.576-.007 1.098 3.403 2.898 2.097L21.35 12l1.112 3.4-2.898 2.096-1.098 3.403-3.577-.007L12 23l-2.89-2.108-3.576.007-1.098-3.403-2.898-2.097L2.65 12 1.538 8.6l2.898-2.096 1.098-3.403 3.577.007L12 1zm2.24 4.109l2.77-.005.852 2.637 2.245 1.625L19.246 12l.861 2.634-2.245 1.625-.851 2.637-2.772-.005L12 20.524l-2.24-1.633-2.77.005-.852-2.637-2.245-1.625L4.754 12l-.861-2.634L6.138 7.74l.851-2.637 2.772.005L12 3.476l2.24 1.633z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;